<template>
  <div id="app" :class="{ 'in-iframe': isInIframe() }">
    <div class="main" v-if="!isInIframe()">
      <NavigationBar></NavigationBar>
      <router-view />
      <SiteFooter></SiteFooter>
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import SiteFooter from "@/components/SiteFooter.vue";
import { useAuthenticateStore } from "@/store/AuthenticateStore.js";
import cookieHelper from '@/_helpers/cookie.js'
import { useIframe } from '@/composables/useIframe';
import { ref, onMounted } from 'vue';

export default {
  components: {
    SiteFooter,
    NavigationBar,
  },

  setup() {
    document.title = "Rosenstrasse Foundation";

    const authenticateStore = useAuthenticateStore();
    const { isInIframe } = useIframe();
    const inIframe = ref(false);

    onMounted(() => {
      inIframe.value = isInIframe();
    });

    return { 
      authenticateStore,
      isInIframe: () => inIframe.value
    }
  },

  async created() {
    await this.authenticateStore.checkAuthentication();
    if (!this.authenticateStore.getAuthentication) {
      cookieHelper.deleteCookie('id_token');
      this.authenticateStore.checkAuthentication();
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/_shared.scss";

#app {
  color: black;
  font-family: "Crimson Pro";
  font-size: 24px;
  font-weight: 300;
}

.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 42px;
  padding-bottom: 0px;
}
</style>